import { render } from "./SelecionarPessoa.vue?vue&type=template&id=44b8d8be&scoped=true&ts=true"
import script from "./SelecionarPessoa.vue?vue&type=script&lang=ts"
export * from "./SelecionarPessoa.vue?vue&type=script&lang=ts"

import "./SelecionarPessoa.vue?vue&type=style&index=0&id=44b8d8be&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b8d8be"]])

export default __exports__